import classes from "./integration.module.scss";

const IntegrationSyncMessage = ({ messageLines }) => {
	if (!messageLines || messageLines.length === 0) {
		return null;
	}

	return (
		<ul className={classes.syncMessageList}>
			{messageLines.map((line, index) => (
				<li key={index}>{line}</li>
			))}
		</ul>
	);
};

export default IntegrationSyncMessage;
